import { defineMessages } from "react-intl";

/**
 * TPA Learning Center consent modal copy (SFCC-11508). Button labels only —
 * the modal body is Builder-authored HTML (`modalContent`), not i18n'd here.
 */
export const tpaLearningCenterConsentMessages = defineMessages({
  decline: {
    id: "tpa_learning_center_consent.decline",
    defaultMessage: "No Thanks",
  },
  accept: {
    id: "tpa_learning_center_consent.accept",
    defaultMessage: "Yes, I'm IN",
  },
  title: {
    id: "tpa_learning_center_consent.title",
    defaultMessage: "TPA Learning Center Consent",
  },
  description: {
    id: "tpa_learning_center_consent.description",
    defaultMessage: "TPA Welcome Learning Center consent popup modal",
  },
});
